import {
  useTheme,
  Stack,
  Box,
  Paper,
  Typography,
  Chip,
  Button,
  Modal,
  IconButton,
} from "@mui/material";
import { ptBR } from "@mui/x-data-grid/locales";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";

import useStyles from "../styles";
import { useOutletContext } from "react-router-dom";
import dayjs from "dayjs";
import { useState } from "react";
import ModalERP from "../../../componentes/easyLogs/modalERPv2";

export const HistoricoEasyLog = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [openModal, setOpenModal] = useState(false);
  const [ipCliente, setIpCliente] = useState("");

  const {
    CustomNoRowsOverlay,
    ButtonExports,
    loadingEvents,
    rowsEvents,
    eventos,
    protocolos,
    typeDB = "nat",
    erpStatus = false,
  } = useOutletContext();
  const apiRefEvents = useGridApiRef();
  const columnsBpa = [
    { field: "Exporter", headerName: "Exporter", flex: 1 },
    {
      field: "Evento",
      headerName: "Evento",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack sx={styles.containerColumnChip} spacing={1}>
            {params.value == "1" && (
              <Chip sx={styles.chipAdd} label={"+ " + eventos?.[1]} />
            )}
            {params.value == "2" && (
              <Chip sx={styles.chipDel} label={"- " + eventos?.[2]} />
            )}
          </Stack>
        );
      },
    },
    {
      field: "Protocolo",
      headerName: "Protocolo",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack sx={styles.containerColumnChip} spacing={1}>
            <Chip
              sx={styles.chipProtocol}
              label={protocolos?.[parseInt(params.value)]}
            />
          </Stack>
        );
      },
    },
    {
      field: "IP Público",
      headerName: "IP Público",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "IP Privado",
      headerName: "IP Privado",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return erpStatus ? (
          <Button
            onClick={() => {
              setOpenModal(true);
              setIpCliente(params.value);
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                textDecoration: `underline ${theme.palette.easyLog.tertiary}`,
                color: theme.palette.easyLog.tertiary,
              }}
            >
              {params.value}
            </Typography>
          </Button>
        ) : (
          params.value
        );
      },
    },
    {
      field: "Porta Inicial",
      headerName: "Porta Inicial",
      width: 100,
      align: "center",
    },
    {
      field: "Porta Final",
      headerName: "Porta Final",
      width: 90,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Horário",
      headerName: "Horário",
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        //let data = new Date(params.value).toLocaleString();
        return dayjs(params.value).utc().format("DD/MM/YYYY HH:mm:ss");
      },
    },
  ];
  const columnsNat = [
    { field: "Exporter", headerName: "Exporter", flex: 1 },
    {
      field: "IP Público",
      headerName: "IP Público",
      width: 160,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "IP Privado",
      headerName: "IP Privado",
      width: 160,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return erpStatus ? (
          <Button
            onClick={() => {
              setOpenModal(true);
              setIpCliente(params.value);
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                textDecoration: `underline ${theme.palette.easyLog.tertiary}`,
                color: theme.palette.easyLog.tertiary,
              }}
            >
              {params.value}
            </Typography>
          </Button>
        ) : (
          params.value
        );
      },
    },
    {
      field: "Porta",
      headerName: "Porta ",
      width: 120,
      align: "center",
    },

    {
      field: "Horário",
      headerName: "Horário",
      width: 210,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        //let data = new Date(params.value).toLocaleString();
        return dayjs(params.value).utc().format("DD/MM/YYYY HH:mm:ss");
      },
    },
  ];
  return (
    <Paper
      sx={{
        ...styles.paper,
        width: "100%",
      }}
    >
      <Stack sx={styles.containerButtomDataGrid}>
        <ButtonExports
          apiRef={apiRefEvents}
          columns={typeDB === "bpa" ? columnsBpa : columnsNat}
        />
      </Stack>

      <Box sx={styles.boxType}>{typeDB === "bpa" ? "CGNAT" : "NAT"}</Box>
      <Typography sx={styles.titlePaper}>
        <Box sx={styles.bar} />
        Histórico de Logs
      </Typography>
      <DataGrid
        apiRef={apiRefEvents}
        loading={loadingEvents}
        density="compact"
        sx={{ ...styles.dataGrid, "--DataGrid-overlayHeight": "300px" }}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: -1,
            },
          },
        }}
        slotProps={{
          loadingOverlay: {
            variant: "skeleton",
            noRowsVariant: "skeleton",
          },
        }}
        hideFooter={true}
        columnVisibilityModel={{ id: false }}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        rows={rowsEvents}
        columns={typeDB === "bpa" ? columnsBpa : columnsNat}
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        disableRowSelectionOnClick
      />
      <ModalERP
        ipCliente={ipCliente}
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      />
    </Paper>
  );
};
